module.exports = __webpack_public_path__ + "static/media/offline.bfec7533.png";